import { NavLink, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { FiBarChart2, FiClipboard, FiGrid, FiSettings, FiUser } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const MobileMenu = () => {
  const { t } = useTranslation();
  const mobileMenus = [
    {
      name: t("side.bar.Dashboard"),
      NavLink: "/Dashboard",
      icon: <FiBarChart2 />,
    },
    {
      name: t("side.bar.Profile"),
      NavLink: "/my-profile",
      icon: <FiUser />,
    },
    {
      name: t("side.bar.Surveys"),
      icon: <FiClipboard />,
      NavLink: "/my-surveys",
      subMenus: [
        { name: t("side.bar.Best"), NavLink: "/my-surveys" },
        { name: t("side.bar.Short"), NavLink: "/short-survey" },
        { name: t("side.bar.Most"), NavLink: "/most-point" },
      ],
    },
    {
      name: t("side.bar.Account"),
      icon: <FiSettings />,
      NavLink: "/accountsection",
    },
    {
      name: t("mobile.sidebar.more"),
      NavLink: "/more",
      icon: <FiGrid />,
      subMenus: [
        { name: t("side.bar.Friend"), NavLink: "/my-referral" },
        { name: t("side.bar.History"), NavLink: "/history" },
        { name: "Wallet History", NavLink: "/wallet-history" },
        { name: t("side.bar.Unsubscribe"), NavLink: "/unsubscribe" },
        { name: t("side.bar.Help"), NavLink: "/raise-query" },
        { name: t("side.bar.Logout"), NavLink: "/logout" },
      ],
    },
  ];
  const location = useLocation();
  const current = location.pathname.replace(/\/+$/, "").toLowerCase();
  const isActive = (menu) =>
    current === menu.NavLink.toLowerCase() ||
    !!menu.subMenus?.some((sub) => sub.NavLink.toLowerCase() === current);

  return (
    <nav className="zs-bottomnav" aria-label="Mobile navigation">
      {mobileMenus?.map((menu, index) => (
        <NavLink
          key={index}
          to={menu.NavLink}
          className={`zs-bottomnav-item ${isActive(menu) ? "is-active" : ""}`}
        >
          <span className="zs-bottomnav-pill">{menu.icon}</span>
          <span className="capitalize truncate max-w-full px-1">{menu.name}</span>
        </NavLink>
      ))}
    </nav>
  );
};

MobileMenu.propTypes = {
  openMenu: PropTypes.number,
};

export default MobileMenu;
